<template>
<div>
  <h4>Regulamin</h4>
  
  <form action="" class="form-horizontal" @submit.prevent="submit">
    <form-group label="Treść regulaminu" :error="errors['regulation.content']">
      <textarea-input v-model="regulation.content" rows="25"></textarea-input>
    </form-group>
  
    <submit-button :submitting="submitting"></submit-button>
  </form>
</div>
</template>
<script>
import SubmitButton from './SubmitButton.vue'
import FormGroup from './FormGroup.vue'
import TextareaInput from './TextareaInput.vue'
import Flash from './../Flash'
import Api from './../api'

export default {
  data () {
    return {
      errors: [],
      submitting: false,
      regulation: {
        content: ''
      }
    }
  },
  components: {
    SubmitButton,
    FormGroup,
    TextareaInput
  },
  methods: {
    submit () {
      this.errors = []
      this.submitting = true
      Api.regulation.put(this.regulation).then(this.onSubmitSuccess, this.updateError).then(() => { this.submitting = false })
    },
    onSubmitSuccess () {
      Flash.success('Zaktualizowano regulamin poprawnie')
    },
    updateError () {
      Flash.error('Niestety nie udało się zaktualizować regulaminu, skontaktuj się z administratorem')
    },
    fetchData () {
      Api.regulation.get().then(this.fetchSuccess)
    },
    fetchSuccess ({ body }) {
      this.regulation = body
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Regulations.vue?509a352f